// Reuse only review cards actually supplied by Judge.me; keep its source intact.
(() => {
  const fingerprints = new WeakMap();
  const products = new Map();
  function addProductThumbnail(card) {
    const link = card.querySelector('.jdgm-product-name a');
    if (!link) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || !/\/products\/[^/]+$/.test(url.pathname)) return;
    const endpoint = url.pathname + '.js';
    if (!products.has(endpoint)) {
      products.set(endpoint, fetch(endpoint, { credentials: 'same-origin' })
        .then(response => response.ok ? response.json() : null).catch(() => null));
    }
    products.get(endpoint).then(product => {
      if (!product || !card.isConnected || link.querySelector('img')) return;
      const variantId = url.searchParams.get('variant');
      const variant = product.variants?.find(item => String(item.id) === variantId);
      const source = variant?.featured_image?.src || product.featured_image;
      if (!source) return;
      const imageUrl = new URL(source, location.origin);
      imageUrl.searchParams.set('width', '144');
      const image = document.createElement('img');
      image.src = imageUrl.href;
      image.alt = product.title || link.textContent.trim();
      image.width = 64;
      image.height = 64;
      image.loading = 'lazy';
      image.className = 'rgc-review-product-image';
      image.addEventListener('error', () => image.remove(), { once: true });
      link.prepend(image);
      link.classList.add('rgc-review-product-link');
    });
  }
  function render() {
    document.querySelectorAll('.jdgm-testimonials-carousel').forEach(root => {
      const source = root.querySelector('.jdgm-content');
      if (!source) return;
      const seen = new Set();
      const cards = [...source.querySelectorAll('.jdgm-testimonial[data-review-id]')].filter(card => {
        const id = card.dataset.reviewId;
        if (!id || seen.has(id)) return false;
        seen.add(id);
        return true;
      });
      if (!cards.length) {
        root.querySelector('.rgc-reviews-grid')?.remove();
        root.classList.remove('rgc-reviews-ready');
        fingerprints.delete(root);
        return;
      }
      const fingerprint = cards.map(card => card.dataset.reviewId + card.innerHTML).join('');
      if (fingerprints.get(root) === fingerprint) return;
      fingerprints.set(root, fingerprint);
      const grid = document.createElement('div');
      grid.className = 'rgc-reviews-grid';
      grid.setAttribute('role', 'list');
      grid.setAttribute('aria-label', 'Customer reviews across River Giants Club');
      cards.forEach(card => {
        const copy = card.cloneNode(true);
        copy.className = 'rgc-review-card';
        copy.removeAttribute('aria-hidden');
        copy.removeAttribute('inert');
        copy.removeAttribute('style');
        copy.removeAttribute('id');
        copy.setAttribute('role', 'listitem');
        copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
        grid.append(copy);
      });
      const existing = root.querySelector('.rgc-reviews-grid');
      if (existing) existing.replaceWith(grid); else root.append(grid);
      root.classList.add('rgc-reviews-ready');
      grid.querySelectorAll('.rgc-review-card').forEach(addProductThumbnail);
    });
  }
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; render(); });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  render();
})();
